import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || "https://bwarga.id/backend",
  timeout: 30000,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const message =
      error.response?.data?.errorCodes?.[0] ||
      error.message ||
      "Terjadi kesalahan. Silakan coba lagi.";
    return Promise.reject({ ...error, userMessage: message });
  },
);

export const getProvinces = (prefix = "", limit = 10) =>
  api.get("/util/province", { params: { prefix, limit } });

export const getCities = (provinceId, prefix = "", limit = 10) =>
  api.get("/util/city", { params: { provinceId, prefix, limit } });

export const registerHousing = (data) => {
  const formData = new FormData();

  formData.append("name", data.name);
  formData.append("description", data.description);
  formData.append("address", data.address);
  formData.append("unit", data.unit);
  formData.append("houseType", data.houseType);
  formData.append("city", data.city);
  formData.append("province", data.province);
  formData.append("mapUrl", data.mapUrl || "");
  formData.append("longitude", data.longitude ?? 0);
  formData.append("latitude", data.latitude ?? 0);
  formData.append("welcomeMessage", data.welcomeMessage || "");
  formData.append("bsiAccountOwned", data.bsiAccountOwned ? "true" : "false");

  formData.append("picName", data.picName);
  formData.append("picNik", data.picNik);
  formData.append("picEmail", data.picEmail);
  formData.append("picPhone", data.picPhone);

  if (data.logoFile) formData.append("logoFile", data.logoFile);
  if (data.npwpFile) formData.append("npwpFile", data.npwpFile);
  if (data.picIdImgFile) formData.append("picIdImgFile", data.picIdImgFile);

  if (data.imgFiles?.length)
    data.imgFiles.forEach((f) => f && formData.append("imgFiles", f));
  if (data.legalDocFiles?.length)
    data.legalDocFiles.forEach((f) => f && formData.append("legalDocFiles", f));

  return api.post("admin/register/request-register", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const getVisitor = (qrCode) => api.get(`visitor/${qrCode}`);

export default api;
